import styled from "styled-components";

export const Container = styled.div`
  pointer-events: ${props => (props.active ? "none" : "auto")};
  cursor: ${props => (props.active ? "not-allowed" : "auto")};
  opacity: ${props => (props.active ? "0.3" : "1")};
`;
